import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import mentorIcon from "../../../../../assets/svg/dashboard/Mentor-iconCircle.svg";
import mentorshipIcon from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import { getActivitySummaryPerformance } from "../AdminMentorAction/dependencies/action";
import { GET_ACTIVITY_SUMMARY_MENTOR_DATA,DOWNLOAD_EXCEL_STARTUP_MENTORSHIP_ONGOING,DOWNLOAD_EXCEL_STARTUP_HOURS_OF_MENTORSHIP } from "../../../../common/constants/ApplicationUrl";
import CohortSummaryModal2 from "../../../../common/cohortSummaryModal2";
import { MENTORSHIP_ALL } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import axios from "axios";
import { getPredefineOptionsList } from "../AdminMentorAction/dependencies/action";
import Modal from "../AllMentorships/Modal/modal";
import Select from "react-select";
import Button from "../Button";
import { getNamesList } from "../AdminMentorAction/dependencies/action";
const StartupMentorshipHours = (props) => {
  const html = document.getElementsByTagName("html")[0];
  const {
    getNamesList,
    getNamesListData,
    getActivitySummaryPerformance,
    getTablePaginate,
    getTableData,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");

  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [chatBoxModalOpen, setChatBoxModalOpen] = useState(false);
  const [mentorRequest, setMentorRequest] = useState();
  const [mentorRequestId, setMentorRequestId] = useState();
  const [maxTotalCount, setMaxTotalCount] = useState(0);
  const [nameListData, setNamesListData] = useState([]);
  const [cohortModalData, setCohortModalData] = useState("");
  const [fromModule, setFromModule] = useState("");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [data, setData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [activeNow, setActiveNow] = useState("ACTIVE");
  const [paginationData, setPaginationData] = useState();
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  useEffect(() => {
    html.style.overflow = "auto";

    getTableFn();
  }, []);
  const getTableFn = () => {
    setActivePage(1);
    let dataAPI = {};
    dataAPI = {
      state: formData.state == "select" ? null : formData?.state?.value, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
      searchField: filterNameValue === "Select" ? "" : filterNameValue,
      country: formData.country == "select" ? "" : formData?.country?.label, // optional
    };
    // axios({
    //   url: MENTORSHIP_ALL,
    //   method: "POST",
    //   data: {
    //     ...dataAPI,
    //     pageFilter: {
    //       pageSize: 10,
    //       currentPage: activePage - 1,
    //       includeCount: true,
    //       sortField: "legalName",
    //       sortOrder: "DESC",
    //       searchField: filterNameValue === "Select" ? "" : filterNameValue,
    //     },
    //     status: activeNow,
    //   },
    // })
    api
      .POST(MENTORSHIP_ALL, {
        ...dataAPI,
        pageFilter: {
          pageSize: 10,
          currentPage: activePage - 1,
          includeCount: true,
          sortField: "legalName",
          sortOrder: "DESC",
          searchField: filterNameValue === "Select" ? "" : filterNameValue,
        },
        status: activeNow,
      })
      .then((res) => {
        setData(res.data.data);
        setPaginationData(res.data.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };
  const {
    startUpApplication,
    startUpApplicationPagineate,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  useEffect(() => {
    // axios({
    //   url: GET_ACTIVITY_SUMMARY_MENTOR_DATA,
    //   method: "post",
    //   data: {
    //     listKey: "Mentor",
    //     status: "NoRequest",
    //   },
    // })
    api
      .POST(GET_ACTIVITY_SUMMARY_MENTOR_DATA, {
        listKey: "Mentor",
        status: "NoRequest",
      })
      .then((res) => {
        setNamesListData(res.data.data);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (nameListData?.length >= nameListValue?.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);

  useEffect(() => {
    let params = {
      status: "NoRequest",
      industry: "",
      function: "",
      state: "",
      mentorId: "",
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getActivitySummaryPerformance(params);
  }, []);

  useEffect(() => {
    if (getTablePaginate && getTablePaginate?.totalElements > maxTotalCount) {
      setMaxTotalCount(getTablePaginate?.totalElements);
    }
  }, [getTablePaginate]);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      width: "13vw",
      whiteSpace: "nowrap",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    if (history?.location?.state?.pageSection === "mentorshipOngoing") {
      setHeading(getStepperData?.Guidedinstructions[6].Heading);
      setInstructionswithRole(
        getStepperData?.Guidedinstructions[6].InstructionswithRole
      );
      setSelectPage(getStepperData?.Guidedinstructions[6].SelectPage);
    } else {
      setHeading(getStepperData?.Guidedinstructions[7].Heading);
      setInstructionswithRole(
        getStepperData?.Guidedinstructions[7].InstructionswithRole
      );
      setSelectPage(getStepperData?.Guidedinstructions[7].SelectPage);
    }
  }, [getStepperData]);
  const ViewApplication = (dpiitNo) => {
    let reRoute = window.open(sample + "/view-StartupApplication", "_blank");
    reRoute.id = dpiitNo;
    reRoute.fromModule = "startUpApplications";
  };
  const redirectProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    // axios({
    //   url: MENTORSHIP_ALL,
    //   method: "POST",
    //   data: {
    //     pageFilter: {
    //       pageSize: 10,
    //       currentPage: pageNumber - 1,
    //       includeCount: true,
    //       sortField: "legalName",
    //       sortOrder: "DESC",
    //     },
    //     status: activeNow,
    //   },
    // })
    api
      .POST(MENTORSHIP_ALL, {
        pageFilter: {
          pageSize: 10,
          currentPage: pageNumber - 1,
          includeCount: true,
          sortField: "legalName",
          sortOrder: "DESC",
        },
        status: activeNow,
      })
      .then((res) => {
        setData(res.data.data);
        setPaginationData(res.data.paginate);
        props.closeLoader();
      })
      .catch((err) => {
        props.closeLoader();
      });
  };

  useEffect(() => {
    const indDefaultObject = {
      value: "select",
      label: "Select Country",
    };

    const indDefaultObject2 = {
      value: "select",
      label: "Select State",
    };

    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });

    newCountryArray.unshift(indDefaultObject);
    State.getStatesOfCountry(newCountrySelect === true ? "IN" : null).map(
      (item) => {
        const newObject = {
          value: item.name,
          label: item.name,
        };

        newStateArray.push(newObject);
        setNewStateOptions(newStateArray);
      }
    );
    newStateArray.unshift(indDefaultObject2);
  }, [newCountrySelect]);

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  const getExcelDownload = () => {
    let url = history?.location?.state?.pageSection === "mentorshipOngoing" ? DOWNLOAD_EXCEL_STARTUP_MENTORSHIP_ONGOING : DOWNLOAD_EXCEL_STARTUP_HOURS_OF_MENTORSHIP;
    let fileName = history?.location?.state?.pageSection === "mentorshipOngoing" ? 'StartupMentorshipOngoing.xls' : 'StartupTotalHoursOfMentorshipReceived.xls';
    api
      .GET(`${url}`, {responseType: "blob",})
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${fileName}`);
        document.body.appendChild(link);
        link.click();
      });
  };
  return (
    <>
      <div
        className={
          history?.location?.state?.pageSection === "mentorshipOngoing"
            ? "startuplastpageboth"
            : "startuplastpagebothoflast"
        }
      >
        {/* <div className="startuplastpageboth"> */}
        <div className="dashboard-main2" style={{ background: "none" }}>
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (
                    history?.location?.state?.fromModule === "activitySummary"
                  ) {
                    localStorage.setItem("activitySummary", "activitySummary");

                    window.location.reload();
                  } else {
                    localStorage.setItem(
                      "mentorDashboardHome",
                      "mentorDashboardHome"
                    );

                    window.location.reload();
                  }
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "217px",
                  left: "71px",
                }}
              >
                Click to Go Activity Summary
              </span>
            </div>
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
            <CohortSummaryModal2
              setModalVisibility={setModalVisibility}
              fromModule={fromModule}
              modalVisibility={modalVisibility}
              mentorShipId={cohortModalData}
              fromPage={"mentorships"}
            />
          </div>
          <div className="iconWith-heading iconheadingdata">
            <div style={{ width: "100%" ,marginLeft:"4rem",whiteSpace:"nowrap"}}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                ACTIVITY SUMMARY:{" "}
                {history?.location?.state?.pageSection === "mentorshipOngoing"
                  ? "STARTUP MENTORSHIPS ONGOING"
                  : "HOURS OF MENTORSHIPS RECEIVED"}
              </h3>
            </div>
            <a onClick={() => getExcelDownload()}>
              <div className="newuserTooltip">
                <img
                  className="excelButton excelbuttonadmindash"
                  src={excelButton}
                  style={{ top: "2.4rem", width: history?.location?.state?.pageSection === "mentorshipOngoing" ? "65%": "95%", left: "1rem" }}
                ></img>
                <span
                  className="tooltiptext   tooltip-bottom admincohort01"
                  style={{ left: "1rem", top: "5.75rem", width: "12vw" }}
                >
                  Download Excel Report
                </span>
              </div>
            </a>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-md-11 display-center mobilementorsummary">
          <div className="admin-bottom-card row">
            <div
              className="mentorImageParent d-flex justify-content-end"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorIcon} className="sidebar-dashboard-icon2" />
            </div>
            <div className="dashboard-bottom-btn3">
              <p className="text-white">STARTUPS</p>
            </div>
            <div class="w-20 newuserTooltip circleBorder maxtotalCount">
              {history?.location?.state?.pageCounter !== undefined &&
                history?.location?.state?.pageCounter}
            </div>
            <div class="w-40 newuserTooltip activitySummaryText last15days">
              {history?.location?.state?.pageSection === "mentorshipOngoing"
                ? "Number of Mentorships Ongoing"
                : "Number of Hours of Mentorships Received"}
            </div>
          </div>

          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer1">
                <div className="row desktopFilterRow">
                  <div
                    className="col-11 filterDivResponsive d-flex justify-content-between"
                    style={{ position: "relative", right: "0.3rem" }}
                  >
                    <div className="user-type-dropdown dropDownWidthFix35 newuserTooltip">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.value);
                          setFilterNameValue(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search Startup"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Startup
                      </span>
                    </div>

                    <div className="user-type-dropdown dropDownWidthFix35 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>

                    <div className="user-type-dropdown dropDownWidthFix35 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown dropDownWidthFix35 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />

                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>
                    <div className="user-type-dropdown dropDownWidthFix35 newuserTooltip">
                      <Select
                        required={true}
                        id="country"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="country"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.country}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              country: e.value == "select" ? null : e,
                            };
                          });

                          setFilterCountry(e.label);

                          if (e.label === "India") {
                            setNewCountrySelect(true);
                          } else {
                            setNewCountrySelect(false);
                            setFormData((user) => {
                              return {
                                ...user,
                                state: "",
                              };
                            });
                          }
                          setNewStateOptions("");
                        }}
                        options={newCountryOptions}
                        placeholder="Country"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Country
                      </span>
                    </div>
                    <div className="user-type-dropdown dropDownWidthFix35 newuserTooltip">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>

                  <div className="col-1 goBtnDivPositionResponsive gotgobtntable4 newuserTooltip">
                    <Button
                      onClick={() => getTableFn(filterName)}
                      text="GO"
                      className="top-btn goBtnResponsive"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>
                  <div className="user-type-dropdown col-2 ">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.value);
                        setFilterNameValue(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Search Startup"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 ">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 ">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 ">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 ">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                          setFilterState("");
                        } else {
                          setNewCountrySelect(false);
                          setFilterState("");
                          setFormData((user) => {
                            return {
                              ...user,
                              state: "",
                            };
                          });
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 ">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      text="GO"
                      onClick={() => getTableFn(filterName)}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Records Found :{" "}
            {paginationData && paginationData?.totalElements} &lt;{" "}
            {paginationData && paginationData?.currentPage} of{" "}
            {paginationData && paginationData?.numPages} &gt;
          </div>
          {data && data?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{
                          verticalAlign: "middle",
                          position: "relative",
                          top: "0.1rem",
                        }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div style={{ verticalAlign: "middle" }}>NO.</div>
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                          position: "relative",
                        }}
                        colspan="2"
                      >
                        <div
                          style={{
                            minWidth: "35.9rem",
                            maxWidth: "36rem",
                          }}
                        >
                          STARTUP
                        </div>
                      </th>

                      <th
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        <div>TOTAL MENTORS</div>
                      </th>
                      <th
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        TOTAL MENTORSHIPS
                      </th>
                      {history?.location?.state?.pageSection !==
                      "mentorshipOngoing" ? (
                        <>
                          <th
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            HOURS SCHEDULED
                          </th>
                          <th
                            style={{
                              verticalAlign: "middle",
                            }}
                          >
                            HOURS COMPLETED
                          </th>
                        </>
                      ) : (
                        ""
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {data &&
                      data.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            item.requestId === indexCounter
                              ? "purpleBackground"
                              : ""
                          }
                        >
                          <td>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "left",
                                alignItems: "center",
                              }}
                            >
                              {index +
                                1 +
                                10 *
                                  (paginationData &&
                                    paginationData?.currentPage - 1)}
                            </div>
                          </td>
                          <td
                            className="incrisingheightforcellphonetop"
                            style={
                              {
                                // display: "flex",
                                // justifyContent: "center",
                              }
                            }
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item.startupLogoPath === null
                                    ? hashImage
                                    : item.startupLogoPath
                                }
                                onClick={() => {
                                  redirectProfile(item.dpiitNumber);
                                }}
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  top: "88px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                              <div className="incrisingheightforcellphone02">
                                <p>{item.startupName}</p>
                                <div
                                  className="d-flex justify-content-end "
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",
                                    width: "40px",
                                    display: "flex",
                                    float: "right",
                                  }}
                                >
                                  <img
                                    src={profile}
                                    style={{
                                      height: "40px",
                                      width: "50px",
                                      maxWidth: "none",
                                      cursor: "pointer",
                                      objectFit: "contain",
                                      position: "relative",
                                    }}
                                    onClick={() => {
                                      redirectProfile(item.dpiitNumber);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                          <td
                            className="matchList-tooltip specifivdix"
                            style={
                              history?.location?.state?.pageSection ===
                              "mentorshipOngoing"
                                ? { minWidth: "49.9rem", maxWidth: "50rem" }
                                : {}
                            }
                          >
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  maxWidth: "240px",
                                  minWidth: "240px",
                                }}
                              >
                                <div>
                                  {item.startupName}
                                  <div className="newuserTooltip">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        ViewApplication(item.dpiitNumber);
                                      }}
                                      className="color-green "
                                    >
                                      {item.dpiitNo}
                                      <span className="tooltiptext-require tooltip-bottomx">
                                        View Startup Application
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>{" "}
                              <div className="newuserTooltip">
                                <img
                                  src={profile}
                                  style={{
                                    height: "40px",
                                    width: "50px",
                                    maxWidth: "none",
                                    cursor: "pointer",
                                    objectFit: "contain",
                                    position: "relative",
                                    top: "3.74rem",
                                  }}
                                  onClick={() => {
                                    redirectProfile(item.dpiitNumber);
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "40px",
                                    top: "105px",
                                    width: "150px",
                                    padding: "3px 10px",
                                  }}
                                >
                                  View Startup Profile
                                </span>
                              </div>
                            </div>
                          </td>
                          <td
                            className="togglediv"
                            style={{
                              verticalAlign: "middle",
                              position: "relative",
                            }}
                          >
                            <div
                              className=""
                              style={
                                history?.location?.state?.pageSection ===
                                "mentorshipOngoing"
                                  ? { minWidth: "7.9rem", maxWidth: "8rem" }
                                  : {
                                      verticalAlign: "middle",
                                      position: "relative",
                                    }
                              }
                            >
                              <div
                                className=""
                                style={{
                                  justifyContent: "left",
                                  display: "flex",
                                  height: "100%",
                                }}
                              >
                                {item.totalMentors}
                              </div>
                              <div
                                className="newuserTooltip "
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "0px",
                                  bottom: "0px",
                                  padding: "10px",
                                }}
                              >
                                <img
                                  src={mentorIcon}
                                  height={40}
                                  width={40}
                                  style={
                                    history?.location?.state?.pageSection ===
                                    "mentorshipOngoing"
                                      ? {
                                          position: "relative",
                                          top: "0.3rem",
                                          left: "0.5rem",
                                        }
                                      : {
                                          position: "relative",
                                          top: "3rem",
                                          left: "0.5rem",
                                        }
                                  }
                                  onClick={() => {
                                    setModalVisibility(true);
                                    setFromModule("Mentor");
                                    setCohortModalData(item.startupId);
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={
                                    history?.location?.state?.pageSection ===
                                    "mentorshipOngoing"
                                      ? {
                                          left: "30px",
                                          top: "60px",
                                          width: "150px",
                                        }
                                      : {
                                          left: "30px",
                                          top: "100px",
                                          minWidth: "8.4rem",
                                          maxWidth: "8.5rem",
                                        }
                                  }
                                >
                                  View Mentors List
                                </span>
                              </div>
                            </div>
                          </td>
                          <td className="togglediv2">
                            <div className="d-flex">
                              <div>
                                {item.totalMentors}
                                <br></br>

                                <div
                                  style={{
                                    cursor: "pointer",
                                    justifyContent: "center",

                                    width: "40px",
                                    display: "flex",
                                    position: "relative",

                                    // left: "1rem",
                                  }}
                                >
                                  <img
                                    src={mentorIcon}
                                    width={40}
                                    onClick={() => {
                                      setModalVisibility(true);
                                      setFromModule("Mentor");
                                      setCohortModalData(item.startupId);
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>

                          <td
                            className="togglediv"
                            style={{
                              verticalAlign: "middle",
                              position: "relative",
                            }}
                          >
                            <div
                              className=""
                              style={{
                                display: "flex",
                              }}
                            >
                              <div
                                className=""
                                style={{
                                  justifyContent: "left",
                                  display: "flex",
                                  height: "100%",
                                }}
                              >
                                {item.totalMentorships}
                              </div>
                              <div
                                className="newuserTooltip "
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "0px",
                                  bottom: "0px",
                                  padding: "10px",
                                }}
                              >
                                <img
                                  src={mentorshipIcon}
                                  height={40}
                                  width={40}
                                  onClick={() => {
                                    let reRoute = window.open(
                                      `/dashboard/mentorship/${item.startupId}`,
                                      "_blank"
                                    );
                                    reRoute.startupData = item;
                                  }}
                                />
                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "20px",
                                    top: "56px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentorship
                                </span>
                              </div>
                            </div>
                          </td>
                          <td
                            className="togglediv2"
                            style={{
                              verticalAlign: "middle",
                              position: "relative",
                            }}
                          >
                            <div className="d-flex">
                              <div>
                                {item.totalMentorships}

                                <div
                                  style={{
                                    cursor: "pointer",
                                    justifyContent: "center",

                                    width: "40px",
                                    display: "flex",
                                    position: "relative",

                                    // left: "1rem",
                                  }}
                                >
                                  <img
                                    src={mentorshipIcon}
                                    height={40}
                                    width={40}
                                    onClick={() => {
                                      let reRoute = window.open(
                                        `/dashboard/mentorship/${item.startupId}`,
                                        "_blank"
                                      );
                                      reRoute.startupData = item;
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          </td>
                          {history?.location?.state?.pageSection !==
                          "mentorshipOngoing" ? (
                            <>
                              <td style={{ verticalAlign: "middle" }}>
                                {item.hoursCompleted}
                              </td>
                              <td style={{ verticalAlign: "middle" }}>
                                {item.hoursScheduled}
                              </td>
                            </>
                          ) : (
                            ""
                          )}
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={
                      paginationData && paginationData?.totalElements
                    }
                    pageRangeDisplayed={5}
                    onChange={handlePageChange.bind(this)}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.AdminMentorReducer.getActivitySummaryPerformance.data,
    getTablePaginate:
      state.AdminMentorReducer.getActivitySummaryPerformance.paginate,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  getActivitySummaryPerformance,
  getPredefineOptionsList,
  getNamesList,
  getStepperTooltipData,
})(withRouter(StartupMentorshipHours));
